import axios, { AxiosError } from "axios";

const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:3000";

export const api = axios.create({
  baseURL: `${API_BASE}/api/admin`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 401 handling.
//
// Critically: a failed *login attempt* (wrong email/password) also returns
// 401. If we blindly clear the token and redirect on every 401, the user
// types a wrong password, the page hard-reloads, the form state and the
// "Geçersiz e-posta veya şifre" message both vanish — they see the login
// page refresh with no explanation. That's what we just fixed.
//
// So we hard-redirect only when:
//   • the failing request was NOT an auth endpoint (otherwise the caller
//     itself shows the error), AND
//   • the user is NOT already on /login (otherwise the redirect is a
//     pointless reload that wipes form state).
//
// Everything else just rejects and lets the calling code handle it.
api.interceptors.response.use(
  (res) => res,
  (error: AxiosError) => {
    const url = error.config?.url || "";
    const isAuthEndpoint = url.includes("/auth/");
    const alreadyOnLogin =
      typeof window !== "undefined" && window.location.pathname === "/login";

    if (error.response?.status === 401 && !isAuthEndpoint && !alreadyOnLogin) {
      localStorage.removeItem("admin_token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);
